import React from 'react';
import { InfoCard } from '@latitude/info-card';
import { Text } from '@latitude/text';
import { Link } from '@latitude/link';
import { Box } from '@latitude/box';
import { Vertical } from '@latitude/spacing';

const CorporateResponsibilityReconciliationAction = () => {
  return (
    <Box paddingBottom="30px">
      <InfoCard bodyBGColor="#E8F4FF" heading="Reconciliation Action Plan">
        <Vertical spacing="24px">
          <Box>
            <Text align="center">
              Our Reflect Reconciliation Action Plan marks an important step in
              our commitment to respect, inclusion and meaningful action with
              First Nations peoples. We&rsquo;re focused on building cultural
              understanding, creating opportunities, and embedding
              reconciliation in how we work &#8211; inside and outside Latitude.
            </Text>
            <Link
              button="tertiary"
              href="https://assets.latitudefinancial.com/corporate-responsibility/reconciliation-action-plan.pdf"
              trackId="corporate-responsibility-reconciliation-action"
              width="200px"
              css={`
                margin: 20px auto 0;
              `}
            >
              Read more
            </Link>
          </Box>
        </Vertical>
      </InfoCard>
    </Box>
  );
};

export default CorporateResponsibilityReconciliationAction;
